import React from 'react';
import { cn } from '../../shared/utils';

const Button = ({ children, onClick, variant = 'primary', className = '', icon: Icon, disabled, ...props }) => {
    const baseStyle = "px-4 py-2 rounded-lg font-medium transition-all duration-200 flex items-center justify-center gap-2 active:scale-95 disabled:opacity-50 disabled:cursor-not-allowed";
    const variants = {
        primary: "bg-[#7e22ce] hover:bg-[#6b21a8] text-white shadow-md shadow-purple-200", // Shiprocket Purple
        secondary: "bg-white border border-slate-200 hover:bg-slate-50 text-slate-700",
        danger: "bg-red-500 hover:bg-red-600 text-white",
        ghost: "hover:bg-slate-100 text-slate-600"
    };

    return (
        <button onClick={onClick} disabled={disabled} className={cn(baseStyle, variants[variant], className)} {...props}>
            {Icon && <Icon size={20} />}
            {children}
        </button>
    );
};

export default Button;
